export enum EApiUrl {
  PRODUCTION = 'https://api.miloto.es/public/api/v1/',
  DEVELOP = 'https://api.dev.miloto.com/public/api/v1/',
  LOCAL = 'http://127.0.0.1:8000/api/v1/',
  LOCAL_INTRANET = 'http://192.168.1.89:8000/api/v1/',
  //LotoUp Urls
  LOTOUP_LOCAL = 'http://127.0.0.1:8000/api/',
  LOTOUP_DEV = 'http://138.68.83.89/api/',
  LOTOUP_PROD = 'https://api.lotoup.com/api/'
}